import React from "react";
import {observer} from "mobx-react-lite";
import AdminMenu from "./AdminMenu";

const AdminHome = () => {
    return (
        <main>
            <AdminMenu/>
            <h1>Admin Home</h1>
        </main>
    )
}
export default observer(AdminHome);